// VEDI PROGETTO calendar/calendar per il setup della conf e la gestione della personalizzazione
import { DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import utc from 'dayjs/plugin/utc'; // https://day.js.org/docs/en/installation/installation
import timezone from 'dayjs/plugin/timezone';
import dayjs from 'dayjs';
import { useEffect, useReducer } from "react";

dayjs.extend(utc);
dayjs.extend(timezone);
var toObject = require("dayjs/plugin/toObject");
dayjs.extend(toObject)

export default function DatePickerCustomizable({opt, id, conf, updateConf, setConf}){

    //prove
    /* opt.views = ['year', 'month']
    opt.defaultDate = null
    opt.minDate = "2018-02"
    opt.maxDate = null
    opt.dateOffset = null */
    /* opt.dateOffset = {
        unit: "year",
        value: 3
    } */

    var defaultDate;
    if(opt.defaultDate == "AutoYear"){
        defaultDate = dayjs().startOf('year');
    }
    else if(opt.defaultDate == "AutoMonth"){
        defaultDate = dayjs().startOf('month');
    }
    else if(opt.defaultDate == "AutoDate"){
        defaultDate = dayjs();
    }
    else if(opt.defaultDate == null){
        defaultDate = "";
    }
    else{
        defaultDate = dayjs(new Date(opt.defaultDate));
    }

    var minDate;
    if(opt.minDate == "AutoYear"){
        minDate = dayjs().startOf('year');
    }
    else if(opt.minDate == "AutoMonth"){
        minDate = dayjs().startOf('month');
    }
    else if(opt.minDate == "AutoDate"){
        minDate = dayjs();
    }
    else if(opt.minDate == null){
        minDate = "";
    }
    else{
        minDate = dayjs(new Date(opt.minDate));
    }

    var maxDate;
    if(opt.maxDate == "AutoYear"){
        maxDate = dayjs().startOf('year');
    }
    else if(opt.maxDate == "AutoMonth"){
        maxDate = dayjs().startOf('month');
    }
    else if(opt.maxDate == "AutoDate"){
        maxDate = dayjs();
    }
    else if(opt.maxDate == null){
        maxDate = "";
    }
    else{
        maxDate = dayjs(new Date(opt.maxDate));
    }

    //CONF OFFSET LOGIC
    if(opt.dateOffset){
        if((minDate && maxDate) || (!minDate && !maxDate)){
            throw(new Error("Errore nel file di configurazione, option DatePickerCustomizable. Se dateOffset è settato allora deve essere impostata una e soltanto una opzione tra minDate o maxDate."));
        } 
        if(minDate){
            maxDate = minDate.add(opt.dateOffset.offsetValue, opt.dateOffset.unit)
        } 
        if(maxDate){
            minDate = maxDate.subtract(opt.dateOffset.offsetValue, opt.dateOffset.unit)
        } 
    }

    //https://react.dev/learn/extracting-state-logic-into-a-reducer
    const [date, dispatch] = useReducer(DatePickerCustomizableReducer, {value:defaultDate, conf:conf})

    const handleChangeDatePickerCustomizable = async (changedValue)=> {
        await dispatch({
            type: 'changed',
            payload: {
                changedValue: changedValue,
                optId: id,
                conf: conf,
                updateConf: updateConf,
                setConf: setConf
            }
        })
        setConf(date.conf)
    }

    //setto il valore di default nella conf
    useEffect(() => {
        const hasNoValue = !conf.selectedPaginationOptions[id].value;
        if(hasNoValue && defaultDate){
            handleChangeDatePickerCustomizable(defaultDate);
        }
    }, [conf.selectedPaginationOptions[id].value]);

    return(
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
                label={opt.nome} //get from conf
                views={opt.views} //get from conf
                defaultValue={date.value == ""?undefined:date.value}
                minDate={minDate == ""?undefined:minDate}
                maxDate={maxDate == ""?undefined:maxDate}
                timezone={opt.timezone} //get from conf
                onChange={(newValue, context) => {
                    handleChangeDatePickerCustomizable(newValue);
                }}
            />
        </LocalizationProvider>
    )

}

function DatePickerCustomizableReducer (date, action){

    const handleChange = () => {
        const newConf = { ...action.payload.conf };
        const {milliseconds, seconds, minutes, hours, ...valueToSet} = action.payload.changedValue.toObject() //prendo solo giorni mesi e anni
        newConf.selectedPaginationOptions[action.payload.optId].value = valueToSet;
        newConf.selectedPaginationOptions[action.payload.optId].value.months += 1;
        /* action.payload.setConf(newConf) */
        return newConf
    }

    switch (action.type){
        case 'changed': {
            const conf = handleChange()
            return {value:action.payload.changedValue, conf:conf};
        }
        default: {
            throw Error('Unknown action: ' + action.type);
        }

    }
}